import { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { IntlProvider } from "react-intl";
import {
  SETTING_STORAGE_KEY,
  DEFAULT_FALLBACK_LANGUAGE
} from "../data/constant";
import { useLocalStorage } from "../hooks/useLocalStorage";
const LanguageContext = createContext();

export const LanguageProvider = (props) => {
  const [storedValue, setValue] = useLocalStorage(SETTING_STORAGE_KEY, {
    language: DEFAULT_FALLBACK_LANGUAGE
  });

  const getLanguage = () => {
    return storedValue ? storedValue.language : DEFAULT_FALLBACK_LANGUAGE;
  };

  const setLanguage = (lang) => {
    setValue({ language: lang });
  };

  const messageResolver = () => {
    switch (getLanguage()) {
      case "th":
        return require("../languages/th.json");
      default:
        return require("../languages/en.json");
    }
  };

  return (
    <LanguageContext.Provider
      value={{
        lang: getLanguage(),
        setLang: setLanguage
      }}
    >
      <IntlProvider
        messages={messageResolver()}
        key={getLanguage()}
        locale={getLanguage()}
        defaultLocale={DEFAULT_FALLBACK_LANGUAGE}
      >
        {props.children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node
};

export const useLang = () => useContext(LanguageContext);
